import './vendor/swiper.js';
import {Fancybox} from '@fancyapps/ui';

Fancybox.bind('[data-fancybox]', {
  // Your custom options for a specific gallery
});
